export class LlmModelDTO {
    id: string;
    displayName: string;
    modelName: string;
    enabled: boolean;
    isSelected?: boolean;
  isDefault: boolean;

    constructor(data?: Partial<LlmModelDTO>) {
        if (data) {
            this.bindData(data);
        } else {
            this.initialize();
        }
    }

    bindData(data: Partial<LlmModelDTO>): void {
        if (data) {
            this.id = data.id || '';
            this.displayName = data.displayName || '';
            this.modelName = data.modelName || '';
            this.enabled = data.enabled !== undefined ? data.enabled : true;
            this.isSelected = data.isSelected || false;
            this.isDefault = data.isDefault || false;
        }
    }

    private initialize(): void {
        this.id = '';
        this.displayName = '';
        this.modelName = '';
        this.enabled = true;
        this.isSelected = false;
        this.isDefault = false;
    }
}
